import React, { Component } from 'react';
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap';
import rightarrow from '../../../assets/img/icons/rightarrow.svg'
import activearrow from '../../../assets/img/icons/activearrow.svg' 
import axios from 'axios';
import ReactHtmlParser from 'react-html-parser';
import { Trans } from "react-i18next";   
import "../../../config/i18n";
import { withTranslation } from "react-i18next";

class Help extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showNav3: false,helppages:[],current_id:'',current_des:'',current_title:'',social_link:[],fb_link:'',
            google_link:'',twitter_link:'',instagram_link:'',tiktok_link:'',api_url:localStorage.getItem('api_url'),limit:8,loadmore:'none',
            langKey: "en",
        }
    }

    componentDidMount(){
        if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }
        
        this.setState({
            loader:'loder-icon'
        });
        setTimeout(() => {
            this.setState({
                profilespace: 'content-wrapper homepg resp-width100 float-left',
                loader: 'none'
            });
          }, 2000);

        const { match: { params } } = this.props;
        var helpId = (typeof params.Id === 'undefined') ? 0 : (params.Id - 1);  
            helpId = (helpId > 0) ? helpId : 0;  

        var details = new FormData();
        details.append('user_id',JSON.parse(localStorage.getItem('session_userid')));
        details.append('language', this.state.langKey);   

        axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
        axios({
            method: 'post',    
            url: this.state.api_url+'webhelppages', 
            data: details,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {     
            const helppages = res.data.helppages;
            const social_link = res.data.landingpage;

            helpId = (typeof helppages[helpId] === 'undefined') ? 0 : helpId; 

            this.setState({ 
                helppages: res.data.helppages,
                current_id: helppages[helpId].id,
                current_title: helppages[helpId].title,
                current_des: helppages[helpId].description, 
                fb_link: social_link[helpId].fb_link,
                // instagram_link: social_link[1].google_link,
                twitter_link: social_link[2].twitter_link,
                instagram_link: social_link[3].instagram_link,
                tiktok_link: social_link[4].tiktok_link,

            });
        }).catch(error => {
            this.props.history.push("/app/NotFound");
        });  
    
    }

    render() {
        return (
            <div className="common_layout">
                <div className='header_layout'>
                    <div className='header_title margin_auto'>
                        <h4><Trans i18nKey="Help">Help</Trans></h4>
                    </div>
                </div>
                <div className='mt_3'>
                    <Container>
                        <Tab.Container id="left-tabs-example" defaultActiveKey="privacypolicy">
                            <Row>
                                <Col md={5}>
                                    <div className=''>
                                        <Nav variant="pills" className="flex-column settings_tab">
                                            {this.state.helppages.map((helppages) =>  
                                                <Nav.Item>
                                                    <Nav.Link className={helppages.id === this.state.current_id ? "settings_a active" : "settings_a"} onClick={() => this.setState({  current_id: helppages.id,current_title: helppages.title,current_des: helppages.description   })} >
                                                        <h4>{helppages.title}</h4>
                                                        <img src={rightarrow} alt='img' className="nrml_img" />
                                                        <img src={activearrow} alt='img' className="active_img" />
                                                    </Nav.Link>
                                                </Nav.Item>
                                            )}
                                        </Nav>
                                    </div>
                                </Col>
                                <Col md={6} className='margin_xauto'>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="privacypolicy" className=''>
                                            <div className='help_content_div'>
                                                <div className='help_content_title'>
                                                    <h4>{this.state.current_title}</h4>
                                                </div>
                                                <div className='help_content_para'>
                                                    {this.state.current_des && ReactHtmlParser(this.state.current_des)}
                                                </div>
                                            </div>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Container>
                </div>
            </div >
        );
    }
}

export default withTranslation("translations")(Help);
